<template>
  <layout-login>
    <h2 class="invite-title">
      {{ $t('message["1240"]') }}
    </h2>
    <div>
      <cube-form
        :model="model"
        :options="options"
        @validate="validateHandler"
        @submit.prevent="submitHandler"
      >
        <cube-form-item :field="fields[0]" />
        <div class="cube-form-item-box">
          <cube-form-item :field="fields[1]" />
          <div class="find-pwd-box">
            <cube-form-item :field="fields[2]" />
          </div>
        </div>
        <cube-form-group>
          <cube-button
            type="submit"
            :primary="true"
          >
            {{ $t('message["597"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </layout-login>
</template>

<script type="text/ecmascript-6">
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { mapActions } from 'vuex'
import { setAuth } from '@/lib/storage'
import { accountFields, options } from '@/components/mobile/invite/common'
export default {
  components: {
    LayoutLogin
  },
  data () {
    return {
      isValid: false,
      model: {
        account: '',
        password: ''
      },
      options,
      fields: accountFields
    }
  },
  computed: {
    inviteLogin () {
      const { mobile, invitecode, ensecret } = this.$route.query
      return { mobile, invitecode, ensecret }
    }
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxSave', 'ajaxLastJoin']),
    async submitHandler (e) {
      if (this.isValid) {
        let params = Object.assign(this.model, this.inviteLogin)
        const chain = await this.ajaxSave()
        chain.params(params)
          .onSuccess(async (raw, res) => {
            if (!res.error) {
              const { Authorization } = res.payload
              setAuth(Authorization)
              await this.$store.commit('setAuth', Authorization, { root: true })
              const chain = await this.ajaxLastJoin()
              chain.params({ invitecode: this.$route.query.invitecode })
                .onSuccess((raw, res) => {
                  if (!res.error) {
                    this.$router.push({ name: 'OrgIndex' })
                  }
                })
                .fetch()
            }
          })
          .setForm(this.form)
          .fetch()
      }
    },
    validateHandler (result) {
      const { valid } = result
      this.isValid = valid
    }
  }
}
</script>

<style scoped lang="scss">
.invite-title {
  width: 279px;
  margin: 30px auto;
}
.invite-title, .invite-company {
  color: #333;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  .invite-company {
    margin: 0 5px;
  }
}
</style>
